import { css } from '@bts-web/utils-style-engine';
import {
  SelectWalletHostScreen,
  type SelectWalletHostScreenProps,
} from '../SelectWalletHostScreen/SelectWalletHostScreen';
import { Drawer } from '../../../../common/components/Drawer/Drawer';
import { useModalDrawerContext } from '../../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { RegularChevronRight } from '../../../../common/svgIcons';

interface SelectWalletHostProps
  extends Omit<SelectWalletHostScreenProps, 'onClose'> {
  className: string;
}

const SelectWalletHostButton = ({
  selectedWalletHost,
  onSelectWalletHost,
  className,
  translations,
  walletHosts,
}: SelectWalletHostProps) => {
  const { openDrawer } = useModalDrawerContext();

  return (
    <div
      className={css({
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        position: 'relative',
      })}
      onClick={() => {
        openDrawer(
          () => (
            <Drawer hideDefaultHeader>
              <SelectWalletHostScreen
                walletHosts={walletHosts}
                translations={translations}
                selectedWalletHost={selectedWalletHost}
                onSelectWalletHost={onSelectWalletHost}
              />
            </Drawer>
          ),
          { disableCloseButton: true },
        );
      }}
    >
      <input
        readOnly
        value={selectedWalletHost?.name || ''}
        placeholder={translations.chooseWalletHost}
        className={`${className ?? ''} ${css({
          cursor: 'pointer',
        })}`}
      />
      <RegularChevronRight
        className={css({
          right: 'small',
          position: 'absolute',
        })}
        size={20}
      />
    </div>
  );
};

export { SelectWalletHostButton };
